module.exports = __webpack_public_path__ + "static/media/coupons-empty.d35d3575.svg";